"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import { IconUpload, IconX } from "@xefi/x-react/icons";
import { useTranslation } from "react-i18next";
import { ACCEPTED_IMPORT_EXTENSIONS } from "./importConstants";
import { formatFileSize } from "@/utils/formatFileSize";
type Props = {
  file: File | null;
  onFileSelect: (file: File | null) => void;
  disabled?: boolean;
};
export default function ImportDropzone(t0) {
  const $ = _c(61);
  const {
    file,
    onFileSelect,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const {
    t
  } = useTranslation();
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  let t2;
  if ($[0] !== onFileSelect) {
    t2 = files => {
      if (!files || files.length === 0) {
        return;
      }
      onFileSelect(files[0]);
    };
    $[0] = onFileSelect;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleFiles = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      (document.activeElement as HTMLElement | null)?.blur();
      inputRef.current?.click();
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const openFilePicker = t3;
  if (file) {
    let t4;
    if ($[3] !== t) {
      t4 = t("paymentsReceived.import.file");
      $[3] = t;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== t4) {
      t5 = <p className="mb-1 text-sm">{t4}</p>;
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    const t6 = file.name;
    let t7;
    if ($[7] !== file.size) {
      t7 = formatFileSize(file.size);
      $[7] = file.size;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    let t8;
    if ($[9] !== t7) {
      t8 = <span className="text-xs text-gray-400">({t7})</span>;
      $[9] = t7;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    let t9;
    if ($[11] !== file.name || $[12] !== t8) {
      t9 = <span className="truncate text-sm text-foreground dark:text-white">{t6}{" "}{t8}</span>;
      $[11] = file.name;
      $[12] = t8;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== t) {
      t10 = t("paymentsReceived.import.cancel");
      $[14] = t;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] !== onFileSelect) {
      t11 = () => onFileSelect(null);
      $[16] = onFileSelect;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    let t12;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <IconX size={18} />;
      $[18] = t12;
    } else {
      t12 = $[18];
    }
    let t13;
    if ($[19] !== disabled || $[20] !== t10 || $[21] !== t11) {
      t13 = <button type="button" aria-label={t10} className="ml-3 shrink-0 text-gray-400 hover:text-danger disabled:cursor-not-allowed" onClick={t11} disabled={disabled}>{t12}</button>;
      $[19] = disabled;
      $[20] = t10;
      $[21] = t11;
      $[22] = t13;
    } else {
      t13 = $[22];
    }
    let t14;
    if ($[23] !== t13 || $[24] !== t9) {
      t14 = <div className="flex items-center justify-between rounded-lg border border-border px-4 py-3 dark:border-[#3a3a3a]">{t9}{t13}</div>;
      $[23] = t13;
      $[24] = t9;
      $[25] = t14;
    } else {
      t14 = $[25];
    }
    let t15;
    if ($[26] !== t14 || $[27] !== t5) {
      t15 = <div>{t5}{t14}</div>;
      $[26] = t14;
      $[27] = t5;
      $[28] = t15;
    } else {
      t15 = $[28];
    }
    return t15;
  }
  let t4;
  if ($[29] !== t) {
    t4 = t("paymentsReceived.import.file");
    $[29] = t;
    $[30] = t4;
  } else {
    t4 = $[30];
  }
  let t5;
  if ($[31] !== t4) {
    t5 = <p className="mb-1 text-sm">{t4}</p>;
    $[31] = t4;
    $[32] = t5;
  } else {
    t5 = $[32];
  }
  const t6 = `flex cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed py-8 transition-colors ${isDragging ? "border-primary bg-[#E8F4FB] dark:bg-[#003a5c]" : "border-[#C4C4C4] bg-[#F2F2F2] dark:border-[#555] dark:bg-[#2a2a2a]"} ${disabled ? "pointer-events-none opacity-60" : ""}`;
  let t7;
  let t8;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => {
      event.preventDefault();
      setIsDragging(true);
    };
    t8 = () => setIsDragging(false);
    $[33] = t7;
    $[34] = t8;
  } else {
    t7 = $[33];
    t8 = $[34];
  }
  let t9;
  if ($[35] !== handleFiles) {
    t9 = event_0 => {
      event_0.preventDefault();
      setIsDragging(false);
      handleFiles(event_0.dataTransfer.files);
    };
    $[35] = handleFiles;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = ACCEPTED_IMPORT_EXTENSIONS.join(",");
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== handleFiles) {
    t11 = event_1 => handleFiles(event_1.target.files);
    $[38] = handleFiles;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== disabled || $[41] !== t11) {
    t12 = <input ref={inputRef} type="file" accept={t10} className="hidden" disabled={disabled} onChange={t11} />;
    $[40] = disabled;
    $[41] = t11;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  let t13;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IconUpload size={22} className="text-[#8D8D8D]" />;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== t) {
    t14 = t("paymentsReceived.import.dropzone");
    $[44] = t;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== t14) {
    t15 = <span className="text-sm font-semibold text-[#8D8D8D] dark:text-[#aaa]">{t14}</span>;
    $[46] = t14;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== t) {
    t16 = t("paymentsReceived.import.accepted");
    $[48] = t;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  let t17;
  if ($[50] !== t16) {
    t17 = <span className="text-xs text-[#8D8D8D] dark:text-[#888]">{t16}</span>;
    $[50] = t16;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== t12 || $[53] !== t15 || $[54] !== t17 || $[55] !== t6 || $[56] !== t9) {
    t18 = <div className={t6} onClick={openFilePicker} onDragOver={t7} onDragLeave={t8} onDrop={t9}>{t12}{t13}{t15}{t17}</div>;
    $[52] = t12;
    $[53] = t15;
    $[54] = t17;
    $[55] = t6;
    $[56] = t9;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  let t19;
  if ($[58] !== t18 || $[59] !== t5) {
    t19 = <div>{t5}{t18}</div>;
    $[58] = t18;
    $[59] = t5;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  return t19;
}